import React, { useState, useEffect, useCallback, useRef } from 'react';
import Webcam from 'react-webcam';
import CanvasDraw from "react-canvas-draw";
import Container from '../../components/container/Container';
import Input, { InputCheckbox } from '../../components/questionnaire/Input';
import { useGetClientFromUrl, useGetQuestionsFromUrl, useGetUnites } from '../../util/hook';
import Client from '../../types/Client';
import Question from '../../types/Question';
import { useParams, Redirect, useHistory } from 'react-router';
import { getQuestionnaire, getChooseQuestionnaire } from '../../util/routes';
import Response from '../../types/Response';
import db from '../../util/database';
import Tables from '../../util/tables';
import Modal from '../../components/modal/Modal';

function Help(props: { client: Client, questionnaire: string }) {
  return (
    <>
      <h3>Remplissez votre questionnaire</h3>
      <p className="mb-4"> -- </p>
      <div className="dbox w-100 d-flex align-items-center">
        <div className="icon d-flex align-items-center justify-content-center">
          <span className="fa fa-user" />
        </div>
        <div className="text pl-3">
          <p>{props.client && <>{props.client.idclient ? `(${props.client.idclient})` : ''} {props.client.nom} {props.client.prenom}</>}</p>
        </div>
      </div>
      <div className="dbox w-100 d-flex align-items-center">
        <div className="icon d-flex align-items-center justify-content-center">
          <span className="fa fa-question" />
        </div>
        <div className="text pl-3">
          <p>{props.questionnaire}</p>
        </div>
      </div>
    </>
  );
}

type QuestionExclude = Exclude<keyof Question, 'test'>;

const videoConstraints = {
  width: 500,
  height: 500,
  facingMode: "environment"
};

const WebcamCapture = ({ onCapture, onZoom, zoom }: { onCapture: (image: string) => void, onZoom: (zoom: boolean) => void, zoom: boolean }) => {
  const webcamRef = React.useRef<any>(null);

  const capture = React.useCallback(
    () => {
      const currentWebCamRef = webcamRef.current;
      if (currentWebCamRef) {
        const imageSrc = currentWebCamRef.getScreenshot();
        onCapture(imageSrc);
      }
    },
    [webcamRef, onCapture],
  );
  const onChangeZoom = useCallback(
    () => {
      onZoom(!zoom);
    },
    [zoom, onZoom],
  );

  const style: React.CSSProperties = zoom ? { width: '100%', height: '100%', left: '0', top: '0' } : { position: 'absolute', top: '0', right: '0' };
  return (
    <>
      <div onClick={onChangeZoom} style={style} className="pointer">
        <Webcam
          audio={false}
          height={zoom ? '100%' : 50}
          width={zoom ? '100%': 50}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={videoConstraints}
          screenshotQuality={1}
        />
        {zoom && <span className="camera fa fa-camera" onClick={capture} />}
      </div>
    </>
  );
};

function Drawer({ onCapture }: { onCapture: (image: string) => void }) {
  const canvasRef = useRef<any>(null);
  const onSave = () => {
    const image = canvasRef.current.canvasContainer.childNodes[1].toDataURL()
    console.log('[Questionnaire] image:', image);
    onCapture(image);
  };
  return (
    <>
    <CanvasDraw brushRadius={5} canvasWidth="100%" canvasHeight="100%" ref={canvasRef} />
    <button onClick={onSave}>Sauvegarder</button>
    </>
  );
}

function CurrentQuestion(props: { questions: Question[], onSubmit: (response: Response) => void, image: string }) {
  const { page, clientId, questionnaire } = useParams<{ page: string, clientId: string, questionnaire: string }>();
  const history = useHistory();
  const currentPage = parseInt(page);
  const [reponses, setReponses] = useState(new Response());
  const unites = useGetUnites();
  useEffect(
    () => {
      const response = new Response();
      if (props.questions[currentPage]) {
        response.currentQuestionnaire = props.questions[currentPage].nom;
        response.question = props.questions[currentPage].question;
        response.questionId = props.questions[currentPage].id;
      }
      setReponses(response);
    },
    [currentPage, props.questions],
  );
  useEffect(
    () => {
      if (unites && unites.length > 0 && !reponses.reponse.valeurUnite) {
        setReponses({ ...reponses, reponse:{ ...reponses.reponse, valeurUnite: unites[0].unite } });
      }
    },
    [unites, reponses],
  );

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name: QuestionExclude = target.name;
    const questionValue: any = value ? props.questions[currentPage][name] : undefined;
    setReponses({ ...reponses, reponse: { ...reponses.reponse, [name]: questionValue || value } });
  };
  const onSubmit = () => {
    props.onSubmit(reponses);
    if (props.questions.length <= currentPage + 1) {
      history.push(getChooseQuestionnaire(parseInt(clientId), true));
    } else {
      history.push(getQuestionnaire(clientId, questionnaire, currentPage + 1));
    }
  };
  let question = null;
  if (props.questions.length === 0) {
    return <div>Chargement...</div>;
  }
  if (props.questions.length <= currentPage) {
    return <Redirect to={getQuestionnaire(clientId, questionnaire)} />
  } else {
    question = props.questions[currentPage];
  }

  console.log('[Questionnaire] reponse:', reponses);
  return (
    <>
    <div className="contact-wrap w-100 p-md-5 p-4">
        <h3 className="mb-4">{question.question}</h3>
        <div id="form-message-warning" className="mb-4" /> 
        <div id="form-message-success" className="mb-4">
          Your message was sent, thank you!
        </div>
        <div id="contactForm" className="contactForm">
          <div className="row">
            <div className="col-md-12 row">
              {question.r1 && <InputCheckbox label={question.r1} type="checkbox" name="r1" checked={!!reponses.reponse.r1} onChange={handleInputChange} />}
              {question.r2 && <InputCheckbox label={question.r2} type="checkbox" name="r2" checked={!!reponses.reponse.r2} onChange={handleInputChange} />}
              {question.r3 && <InputCheckbox label={question.r3} type="checkbox" name="r3" checked={!!reponses.reponse.r3} onChange={handleInputChange} />}
              {question.r4 && <InputCheckbox label={question.r4} type="checkbox" name="r4" checked={!!reponses.reponse.r4} onChange={handleInputChange} />}
              {question.r5 && <InputCheckbox label={question.r5} type="checkbox" name="r5" checked={!!reponses.reponse.r5} onChange={handleInputChange} />}
              {question.r6 && <InputCheckbox label={question.r6} type="checkbox" name="r6" checked={!!reponses.reponse.r6} onChange={handleInputChange} />}
              {question.r7 && <InputCheckbox label={question.r7} type="checkbox" name="r7" checked={!!reponses.reponse.r7} onChange={handleInputChange} />}
              {question.r8 && <InputCheckbox label={question.r8} type="checkbox" name="r8" checked={!!reponses.reponse.r8} onChange={handleInputChange} />}
              <Input type="text" name="reponseLibre" placeholder="Réponse libre" label="Réponse libre" onChange={handleInputChange} />
              <Input size="6" type="text" name="valeurLibre" placeholder="Valeur libre" label="Valeur libre" onChange={handleInputChange} />
              <div className="col-md-3">
                <div className="form-group">
                  <label style={{ lineHeight: '36px', paddingLeft: '10px', width: '100%', color: 'transparent' }}>t</label>
                  <select name="valeurUnite" onChange={handleInputChange}>
                    {unites.map(unite => (<option value={unite.unite}>{unite.unite}</option>))}
                  </select>
                </div>
              </div>
              {props.image && (
                <div className="col-md-3">
                <div className="form-group">
                  <img src={props.image} style={{ width: '100px', height: '100px' }} alt="" />
                </div>
              </div>
              )}
              <div className="col-md-12">
                <div className="form-group">
                  <input type="submit" defaultValue="Send Message" className="btn btn-primary" onClick={onSubmit}/>
                  <div className="submitting" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function Actions({ onClickCamera, onClickDraw }: { onClickCamera: () => void, onClickDraw: () => void }) {
  return (
    <>
    <div className="row" style={{ position: 'absolute', top: '0', right: '0', width: '150px', height: '90px', marginTop: '10px' }}>
      <div style={{ marginRight: '10px' }}>
        <span className="pointer action-icon fa fa-camera" onClick={() => onClickCamera()} />
      </div>
      <div className="">
        <span className="pointer action-icon fa fa-pencil" onClick={() => onClickDraw()} />
      </div>
    </div>
    </>
  );
}

enum Action {
  Camera = 'Camera',
  Drawer = 'Drawer',
  None = 'None',
}

function Questionnaire() {
  const { client } = useGetClientFromUrl();
  const { questions } = useGetQuestionsFromUrl();
  const [actionOpened, setActionOpened] = useState(Action.None);
  const [image, setImage] = useState<string>('');
  const onSubmit = (response: Response) => {
    if (image) {
      response.reponse.photo = image;
    }
    db().collection(Tables.REPONSES).doc(`${client.id}-${response.questionId}`).set(response);
    setImage('');
  };
  const onCapture = (imageSrc: string) => {
    console.log('[Questionnaire] oncapture:', imageSrc);
    setImage(imageSrc);
    setActionOpened(Action.None);
  };
  const getFullWidthComponent = useCallback(
    () => {
      switch (actionOpened) {
        case Action.None: return <span />;
        case Action.Camera: return (
          <Modal onClose={() => setActionOpened(Action.None)} open={actionOpened === Action.Camera} title="Prendre une photo ">
            <WebcamCapture onCapture={onCapture} onZoom={() => setActionOpened(Action.Camera)} zoom={actionOpened === Action.Camera} />
          </Modal>
        );
        case Action.Drawer: return (
          <Modal onClose={() => setActionOpened(Action.None)} open={actionOpened === Action.Drawer} title="Dessiner un croquis ">
            <Drawer onCapture={onCapture} />
          </Modal>
        );
      }
    },
    [actionOpened],
  );
  console.log('[questions] ', questions);

  return (
    <Container title="Visio" leftPanelComponent={<Help client={client} questionnaire={questions && questions.length > 0 ? questions[0].nom : ''} />} fullWidthComponent={getFullWidthComponent()}>
      <CurrentQuestion questions={questions} onSubmit={onSubmit} image={image}/>
      {actionOpened === Action.None && <Actions onClickCamera={() => setActionOpened(Action.Camera)} onClickDraw={() => setActionOpened(Action.Drawer)} />}
    </Container>
  );
}

export default Questionnaire;
